import React from 'react';
import SubmissionsStatus from './SubmissionsStatus';
import SubmissionRecent from './SubmissionRecent';
import { useTranslation } from 'react-i18next';
import CustomerSupportNotice from 'components/Support/CustomerSupportNotice';

const Dashboard: React.FC = () => {
  const { t } = useTranslation('dashboard');
  return (
    <section className="px-4 py-3 space-y-5">
      <h6 className="font-bold text-title">{t('title.title')}</h6>
      {/* YAC-2026-009 PR7b。運営のサポートが入れる状態なら、その期限（無ければ何も出さない）。 */}
      <CustomerSupportNotice />
      <SubmissionsStatus />
      <SubmissionRecent />
    </section>
  );
};

export default Dashboard;
